<template xmlns:v-bind="http://www.w3.org/1999/xhtml" xmlns:v-el="http://www.w3.org/1999/xhtml">
  <svg
    viewBox="0 0 181 172"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink">
    <!-- Generator: Sketch 64 (93537) - https://sketch.com -->
    <title>travel-enthusiasts</title>
    <desc>Created with Sketch.</desc>
    <g
      id="Page-1"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd">
      <g
        id="Desktop-HD"
        transform="translate(-897.000000, -39.000000)">
        <g
          id="travel-enthusiasts"
          transform="translate(898.000000, 41.000000)">
          <g
            id="Background"
            transform="translate(0.000000, 7.136364)">
            <g id="New_Symbol_76-20">
              <path
                id="Path"
                d="M171.490964,82.8636364 C171.529512,49.4379625 151.231711,19.3499824 120.223678,6.86883263 C89.2156461,-5.61231717 53.7335136,2.02348975 30.6045782,26.1549943 C7.47564284,50.2864988 1.35144344,86.0605322 15.1363636,116.511364 L164.188636,116.511364 C168.998056,105.945754 171.488025,94.4723667 171.490964,82.8636364 Z"
                class="fill-extra-light"
                fill-rule="nonzero" />
              <line
                id="Path"
                x1="9.9"
                y1="116.511364"
                x2="169.445455"
                y2="116.511364"
                class="stroke"
                stroke-width="2.04545455"
                stroke-linecap="round"
                stroke-linejoin="round" />
              <line
                id="Path"
                x1="0.695454545"
                y1="116.511364"
                x2="5.80909091"
                y2="116.511364"
                class="stroke"
                stroke-width="2.04545455"
                stroke-linecap="round"
                stroke-linejoin="round" />
              <line
                id="Path"
                x1="173.536364"
                y1="116.511364"
                x2="178.65"
                y2="116.511364"
                class="stroke"
                stroke-width="2.04545455"
                stroke-linecap="round"
                stroke-linejoin="round" />
            </g>
          </g>
          <g
            id="Group"
            transform="translate(6.136364, 8.181818)">
            <rect
              id="Rectangle"
              class="fill-light"
              fill-rule="nonzero"
              x="100.8"
              y="143.181818"
              width="38.8636364"
              height="23.4204545" />
            <rect
              id="Rectangle"
              class="stroke"
              stroke-width="2.04545455"
              stroke-linecap="round"
              stroke-linejoin="round"
              x="100.8"
              y="143.181818"
              width="38.8636364"
              height="23.4204545" />
            <line
              id="Path"
              x1="120.231818"
              y1="150.238636"
              x2="120.231818"
              y2="166.602273"
              class="stroke"
              stroke-width="2.04545455"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <rect
              id="Rectangle"
              class="stroke fill-white"
              stroke-width="2.04545455"
              fill-rule="nonzero"
              stroke-linecap="round"
              stroke-linejoin="round"
              x="100.8"
              y="137.045455"
              width="38.8636364"
              height="6.13636364" />
            <rect
              id="Rectangle"
              class="stroke"
              stroke-width="2.04545455"
              stroke-linecap="round"
              stroke-linejoin="round"
              x="115.118182"
              y="137.045455"
              width="10.2272727"
              height="6.13636364"
              rx="2.04545455" />
            <line
              id="Path"
              x1="115.118182"
              y1="140.113636"
              x2="119.209091"
              y2="140.113636"
              class="stroke"
              stroke-width="2.04545455"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <rect
              id="Rectangle"
              class="stroke"
              stroke-width="2.04545455"
              stroke-linecap="round"
              stroke-linejoin="round"
              x="131.481818"
              y="137.045455"
              width="4.09090909"
              height="6.13636364" />
          </g>
          <path
            id="Path"
            d="M25.5272727,103.295455 C25.5272727,108.981818 23.4818182,113.870455 21.2318182,113.870455 C18.9818182,113.870455 16.9363636,108.981818 16.9363636,103.295455 C16.9363636,97.6090909 21.2318182,82.8409091 21.2318182,82.8409091 C21.2318182,82.8409091 25.5272727,97.6090909 25.5272727,103.295455 Z"
            class="fill-white"
            fill-rule="nonzero" />
          <path
            id="Path"
            d="M25.5272727,103.295455 C25.5272727,108.981818 23.4818182,113.870455 21.2318182,113.870455 C18.9818182,113.870455 16.9363636,108.981818 16.9363636,103.295455 C16.9363636,97.6090909 21.2318182,82.8409091 21.2318182,82.8409091 C21.2318182,82.8409091 25.5272727,97.6090909 25.5272727,103.295455 Z"
            class="stroke"
            stroke-width="2.04545455"
            stroke-linejoin="round" />
          <line
            id="Path"
            x1="21.2318182"
            y1="113.870455"
            x2="21.2318182"
            y2="123.627273"
            class="stroke"
            stroke-width="2.04545455"
            stroke-linejoin="round" />
          <path
            id="Path"
            d="M53.7545455,107.897727 C62.6840576,107.899408 70.1201757,114.748464 70.8545455,123.647727 L82.3909091,123.647727 C69.1851422,103.933481 61.242422,81.1685747 59.3181818,57.5181818 L56.6181818,23.4204545 L50.8909091,23.4204545 L48.1295455,57.5181818 C46.2299419,81.1642917 38.3079607,103.930305 25.1181818,123.647727 L36.6340909,123.647727 C37.3879631,114.749863 44.8248082,107.90832 53.7545455,107.897727 Z"
            class="fill-white"
            fill-rule="nonzero" />
          <path
            id="Path"
            d="M53.7545455,107.897727 C62.6840576,107.899408 70.1201757,114.748464 70.8545455,123.647727 L82.3909091,123.647727 C69.1851422,103.933481 61.242422,81.1685747 59.3181818,57.5181818 L56.6181818,23.4204545 L50.8909091,23.4204545 L48.1295455,57.5181818 C46.2299419,81.1642917 38.3079607,103.930305 25.1181818,123.647727 L36.6340909,123.647727 C37.3879631,114.749863 44.8248082,107.90832 53.7545455,107.897727 Z"
            class="stroke"
            stroke-width="2.04545455"
            stroke-linecap="round"
            stroke-linejoin="round" />
          <path
            id="Path"
            d="M51.8113636,79.2613636 C49.9184604,89.1981428 46.6843399,98.8316934 42.1977273,107.897727 L65.3113636,107.897727 C60.824751,98.8316934 57.5906305,89.1981428 55.6977273,79.2613636 L51.8113636,79.2613636 Z"
            class="stroke fill-light"
            stroke-width="2.04545455"
            fill-rule="nonzero" />
          <path
            id="Path"
            d="M70.0159091,100.738636 L37.4931818,100.738636 C36.2522727,103.643182 34.8886364,106.506818 33.4022727,109.329545 L47.0454545,109.329545 C49.1874226,108.393101 51.4986531,107.905793 53.8363636,107.897727 C56.1676742,107.903931 58.4725998,108.391377 60.6068182,109.329545 L74.0454545,109.329545 C72.6136364,106.506818 71.2431818,103.643182 70.0159091,100.738636 Z"
            class="fill-white"
            fill-rule="nonzero" />
          <path
            id="Path"
            d="M70.0159091,100.738636 L37.4931818,100.738636 C36.2522727,103.643182 34.8886364,106.506818 33.4022727,109.329545 L47.0454545,109.329545 C51.3712994,107.419657 56.3014278,107.419657 60.6272727,109.329545 L74.1272727,109.329545 C72.6136364,106.506818 71.2431818,103.643182 70.0159091,100.738636 Z"
            class="stroke"
            stroke-width="2.04545455"
            stroke-linecap="round"
            stroke-linejoin="round" />
          <line
            id="Path"
            x1="42.3"
            y1="72.1022727"
            x2="65.2090909"
            y2="72.1022727"
            class="stroke"
            stroke-width="2.04545455"
            stroke-linecap="round"
            stroke-linejoin="round" />
          <path
            id="Path"
            d="M43.9363636,72.1022727 L63.5727273,72.1022727 L63.5727273,77.2159091 C63.5727273,78.3455824 62.6569461,79.2613636 61.5272727,79.2613636 L45.9818182,79.2613636 C44.8521448,79.2613636 43.9363636,78.3455824 43.9363636,77.2159091 L43.9363636,72.1022727 L43.9363636,72.1022727 Z"
            class="stroke fill-white"
            stroke-width="2.04545455"
            fill-rule="nonzero"
            stroke-linecap="round"
            stroke-linejoin="round" />
          <path
            id="Path"
            d="M48.6409091,29.1477256 L58.8681818,29.1477256 C59.9978552,29.1477256 60.9136364,30.0635085 60.9136364,31.1931818 L60.9136364,34.7727273 L46.5954545,34.7727273 L46.5954545,31.0909091 C46.6499992,30.0013633 47.5499997,29.1463628 48.6409091,29.1477256 Z"
            class="stroke fill-white"
            stroke-width="2.04545455"
            fill-rule="nonzero"
            stroke-linecap="round"
            stroke-linejoin="round" />
          <polygon
            id="Path"
            class="stroke fill-white"
            stroke-width="2.04545455"
            fill-rule="nonzero"
            stroke-linecap="round"
            stroke-linejoin="round"
            points="46.5954545 34.875 49.4590909 40.6022727 58.05 40.6022727 60.9136364 34.875" />
          <line
            id="Path"
            x1="48.0272727"
            y1="23.4204545"
            x2="59.4818182"
            y2="23.4204545"
            class="stroke"
            stroke-width="2.04545455"
            stroke-linecap="round"
            stroke-linejoin="round" />
          <path
            id="Path"
            d="M50.8909091,23.4204545 L50.8909091,23.175 C50.9111876,20.6160199 51.9402309,18.1683671 53.7545455,16.3636364 L53.7545455,16.3636364 C55.5938864,18.1934054 56.625005,20.6828204 56.6182155,23.2772727 L56.6182155,23.5227273 L50.8909091,23.4204545 Z"
            class="stroke fill-white"
            stroke-width="2.04545455"
            fill-rule="nonzero"
            stroke-linecap="round"
            stroke-linejoin="round" />
          <line
            id="Path"
            x1="53.7545455"
            y1="16.2613636"
            x2="53.7545455"
            y2="9.20454545"
            class="stroke"
            stroke-width="2.04545455"
            stroke-linecap="round"
            stroke-linejoin="round" />
          <line
            id="Path"
            x1="35.1409091"
            y1="93.5795455"
            x2="35.1409091"
            y2="90.7159091"
            class="stroke"
            stroke-width="2.04545455"
            stroke-linecap="round"
            stroke-linejoin="round" />
          <line
            id="Path"
            x1="72.3681818"
            y1="93.5795455"
            x2="72.3681818"
            y2="90.7159091"
            class="stroke"
            stroke-width="2.04545455"
            stroke-linecap="round"
            stroke-linejoin="round" />
          <path
            id="Path"
            d="M35.1409091,93.5795455 L72.3681818,93.5795455 L72.3681818,98.6931818 C72.3681818,99.8228552 71.4524006,100.738636 70.3227273,100.738636 L37.1863636,100.738636 C36.0566903,100.738636 35.1409091,99.8228552 35.1409091,98.6931818 L35.1409091,93.5795455 Z"
            class="stroke fill-white"
            stroke-width="2.04545455"
            fill-rule="nonzero"
            stroke-linecap="round"
            stroke-linejoin="round" />
          <line
            id="Path"
            x1="40.8681818"
            y1="100.738636"
            x2="40.8681818"
            y2="97.875"
            class="stroke"
            stroke-width="2.04545455"
            stroke-linecap="round"
            stroke-linejoin="round" />
          <line
            id="Path"
            x1="48.0272727"
            y1="100.738636"
            x2="48.0272727"
            y2="97.875"
            class="stroke"
            stroke-width="2.04545455"
            stroke-linecap="round"
            stroke-linejoin="round" />
          <line
            id="Path"
            x1="59.4818182"
            y1="100.738636"
            x2="59.4818182"
            y2="97.875"
            class="stroke"
            stroke-width="2.04545455"
            stroke-linecap="round"
            stroke-linejoin="round" />
          <line
            id="Path"
            x1="66.6409091"
            y1="100.738636"
            x2="66.6409091"
            y2="97.875"
            class="stroke"
            stroke-width="2.04545455"
            stroke-linecap="round"
            stroke-linejoin="round" />
          <polyline
            id="Path"
            class="stroke"
            stroke-width="2.04545455"
            stroke-linecap="round"
            stroke-linejoin="round"
            points="49.4590909 40.6022727 58.7045455 49.1931818 48.3545455 54.9204545 59.9931818 63.5113636 46.3909091 70.6704545" />
          <line
            id="Path"
            x1="53.7545455"
            y1="100.738636"
            x2="53.7545455"
            y2="107.897727"
            class="stroke"
            stroke-width="2.04545455"
            stroke-linecap="round"
            stroke-linejoin="round" />
          <line
            id="Path"
            x1="43.7318182"
            y1="100.738636"
            x2="43.7318182"
            y2="109.329545"
            class="stroke"
            stroke-width="2.04545455"
            stroke-linecap="round"
            stroke-linejoin="round" />
          <line
            id="Path"
            x1="63.7772727"
            y1="100.738636"
            x2="63.7772727"
            y2="109.329545"
            class="stroke"
            stroke-width="2.04545455"
            stroke-linecap="round"
            stroke-linejoin="round" />
          <polyline
            id="Path"
            class="stroke"
            stroke-width="2.04545455"
            stroke-linecap="round"
            stroke-linejoin="round"
            points="63.3681818 81.2045455 57.3545455 86.6659091 66.375 91.2886364" />
          <polyline
            id="Path"
            class="stroke"
            stroke-width="2.04545455"
            stroke-linecap="round"
            stroke-linejoin="round"
            points="44.1818182 81.2045455 50.175 86.6659091 41.1545455 91.2886364" />
          <polyline
            id="Path"
            class="stroke"
            stroke-width="2.04545455"
            stroke-linecap="round"
            stroke-linejoin="round"
            points="36.6340909 123.647727 29.3522727 116.918182 43.5068182 111.293182" />
          <polyline
            id="Path"
            class="stroke"
            stroke-width="2.04545455"
            stroke-linecap="round"
            stroke-linejoin="round"
            points="70.8954545 123.647727 78.1772727 116.918182 64.0227273 111.293182" />
          <path
            id="Path"
            d="M55.7795455,0 L58.8477273,0 L58.8477273,9.20454545 L53.7340909,9.20454545 L53.7340909,2.04545455 C53.7340909,0.915781194 54.6498721,0 55.7795455,0 Z"
            class="stroke fill-light"
            stroke-width="2.04545455"
            fill-rule="nonzero"
            stroke-linejoin="round" />
          <rect
            id="Rectangle"
            class="stroke fill-white"
            stroke-width="2.04545455"
            fill-rule="nonzero"
            stroke-linejoin="round"
            x="58.8477273"
            y="0"
            width="5.11363636"
            height="9.20454545" />
          <path
            id="Path"
            d="M63.9613636,0 L67.0295455,0 C68.1592188,0 69.075,0.915781194 69.075,2.04545455 L69.075,7.15909091 C69.075,8.28876426 68.1592188,9.20454545 67.0295455,9.20454545 L63.9613636,9.20454545 L63.9613636,0 Z"
            class="stroke fill-light"
            stroke-width="2.04545455"
            fill-rule="nonzero"
            stroke-linejoin="round" />
          <path
            id="Path"
            d="M140.85,94.0909091 C141.083903,94.0687674 141.312243,94.0064929 141.525,93.9068182 C142.013938,93.6688711 142.388009,93.2460328 142.564561,92.7317285 C142.741113,92.2174243 142.705615,91.6539877 142.465909,91.1659091 C140.184154,87.0797942 139.273619,82.3693882 139.868182,77.7272727 C139.935962,76.5975994 139.075128,75.6268713 137.945455,75.5590909 C136.815781,75.4913105 135.845053,76.3521448 135.777273,77.4818182 C135.143385,82.8369103 136.194399,88.2564248 138.784091,92.9863636 C139.172822,93.751482 139.997837,94.1925791 140.85,94.0909091 L140.85,94.0909091 Z"
            class="stroke fill-white"
            stroke-width="2.04545455"
            fill-rule="nonzero" />
          <path
            id="Path"
            d="M147.538636,91.1863636 L147.661364,91.1863636 C148.785116,91.078532 149.609037,90.0806729 149.502273,88.9568182 C148.438636,77.9522727 147.231818,69.75 141.320455,64.2681818 C140.522651,63.4751108 139.234168,63.4751108 138.436364,64.2681818 C138.049133,64.6522499 137.831322,65.1750596 137.831322,65.7204545 C137.831322,66.2658495 138.049133,66.7886592 138.436364,67.1727273 C142.895455,71.2636364 144.163636,77.4 145.309091,89.2636364 C145.340071,89.8179789 145.595065,90.3359125 146.015519,90.6985058 C146.435973,91.0610991 146.985761,91.2371973 147.538636,91.1863636 Z"
            class="stroke fill-white"
            stroke-width="2.04545455"
            fill-rule="nonzero" />
          <path
            id="Path"
            d="M150.913636,64.4318182 C150.913636,62.1724715 149.082074,60.3409091 146.822727,60.3409091 L146.822727,55.2272727 C146.817069,53.9929943 146.707592,52.7613792 146.495455,51.5454545 C149.215909,57.4363636 154.554545,69.2386364 155.822727,73.7386364 C157.01765,78.5162364 157.791071,83.389469 158.134091,88.3022727 C158.173424,88.8450746 157.994821,89.3811724 157.637807,89.7919302 C157.280793,90.2026881 156.774806,90.4542365 156.231818,90.4909154 L156.088636,90.4909154 C155.012596,90.4935484 154.118502,89.6620407 154.043182,88.5886364 C153.710952,83.9604318 152.985609,79.3688779 151.875,74.8636364 C151.425,73.3090909 150.422727,70.7727273 149.195455,67.7454545 C150.268073,66.9817807 150.907548,65.7485074 150.913636,64.4318182 L150.913636,64.4318182 Z"
            class="stroke fill-white"
            stroke-width="2.04545455"
            fill-rule="nonzero"
            stroke-linejoin="round" />
          <path
            id="Path"
            d="M111.865909,94.0909091 C111.638189,94.0707201 111.416222,94.0082918 111.211364,93.9068182 C110.722425,93.6688711 110.348355,93.2460328 110.171803,92.7317285 C109.99525,92.2174243 110.030749,91.6539877 110.270455,91.1659091 C112.55221,87.0797942 113.462745,82.3693882 112.868182,77.7272727 C112.800401,76.5975994 113.661236,75.6268713 114.790909,75.5590909 C115.920582,75.4913105 116.891311,76.3521448 116.959091,77.4818182 C117.595053,82.8393662 116.536373,88.2615287 113.931818,92.9863636 C113.543087,93.751482 112.718072,94.1925791 111.865909,94.0909091 Z"
            class="stroke fill-white"
            stroke-width="2.04545455"
            fill-rule="nonzero" />
          <path
            id="Path"
            d="M105.197727,91.1863636 L105.075,91.1863636 C103.951247,91.078532 103.127327,90.0806729 103.234091,88.9568182 C104.297727,77.9522727 105.504545,69.75 111.415909,64.2681818 C111.938134,63.710117 112.727923,63.4897554 113.463634,63.6968393 C114.199346,63.9039232 114.75823,64.5039019 114.912681,65.2524337 C115.067132,66.0009655 114.791381,66.7731618 114.197727,67.2545455 C109.759091,71.3454545 108.490909,77.4818182 107.345455,89.3454545 C107.237616,90.4350019 106.290949,91.2464308 105.197727,91.1863636 Z"
            class="stroke fill-white"
            stroke-width="2.04545455"
            fill-rule="nonzero" />
          <path
            id="Path"
            d="M101.822727,64.4318182 C101.822727,62.1724715 103.65429,60.3409091 105.913636,60.3409091 L105.913636,55.2272727 C105.9091,53.9925398 106.018656,52.7600285 106.240909,51.5454545 C103.520455,57.4363636 98.1818182,69.2386364 96.8931818,73.7386364 C95.7115558,78.5181475 94.9450694,83.3908109 94.6022727,88.3022727 C94.5200662,89.4254685 95.3612633,90.4038174 96.4840909,90.4909154 L96.6272727,90.4909154 C97.7033131,90.4935484 98.5974075,89.6620407 98.6727273,88.5886364 C99.0049575,83.9604318 99.7302998,79.3688779 100.840909,74.8636364 C101.290909,73.3090909 102.293182,70.7727273 103.520455,67.7454545 C102.455575,66.977356 101.824084,65.7448077 101.822727,64.4318182 Z"
            class="stroke fill-white"
            stroke-width="2.04545455"
            fill-rule="nonzero"
            stroke-linejoin="round" />
          <path
            id="Path"
            d="M169.2,66.7431818 C168.588353,66.4992428 167.935769,66.3749766 167.277273,66.3749766 C165.197986,66.3687379 163.321941,67.6221299 162.531818,69.5454545 L156.497727,84.4772727 C155.383919,87.1414728 152.77856,88.8756897 149.890909,88.875 L133.527273,88.875 L133.527273,81.8181818 L119.209091,81.8181818 L119.209091,88.8545455 C106.005877,92.1537137 96.7342843,104.004495 96.7090909,117.613636 L96.7090909,122.931818 C96.7090909,123.327204 96.3885675,123.647727 95.9931818,123.647727 C95.5977961,123.647727 95.2772727,123.327204 95.2772727,122.931818 L93.6204545,103.786364 C93.4282017,101.122572 91.2184089,99.0553462 88.5477273,99.0409091 L88.1590909,99.0409091 C86.8048926,99.1297213 85.5427468,99.7574496 84.654814,100.783761 C83.7668813,101.810073 83.3272098,103.149381 83.4340909,104.502273 L85.0909091,123.627273 C85.5879152,129.438254 90.5548926,133.838363 96.3834015,133.630982 C102.21191,133.423601 106.853607,128.68161 106.936364,122.85 L106.936364,145.227273 L145.8,145.227273 L145.8,103.193182 C145.8,100.933835 147.631562,99.1022727 149.890909,99.1022727 L149.890909,99.1022727 C156.927988,99.1015942 163.272427,94.8638964 165.968182,88.3636364 L172.104545,73.4113636 C172.606108,72.1421335 172.581693,70.7254365 172.036694,69.4742425 C171.491696,68.2230486 170.470966,67.2403291 169.2,66.7431818 Z"
            class="fill-white"
            fill-rule="nonzero" />
          <path
            id="Path"
            d="M169.2,66.7431818 C168.588353,66.4992428 167.935769,66.3749766 167.277273,66.3749766 C165.197986,66.3687379 163.321941,67.6221299 162.531818,69.5454545 L156.497727,84.4772727 C155.383919,87.1414728 152.77856,88.8756897 149.890909,88.875 L133.527273,88.875 L133.527273,81.8181818 L119.209091,81.8181818 L119.209091,88.8545455 C106.005877,92.1537137 96.7342843,104.004495 96.7090909,117.613636 L96.7090909,122.931818 C96.7090909,123.327204 96.3885675,123.647727 95.9931818,123.647727 C95.5977961,123.647727 95.2772727,123.327204 95.2772727,122.931818 L93.6204545,103.786364 C93.4282017,101.122572 91.2184089,99.0553462 88.5477273,99.0409091 L88.1590909,99.0409091 C86.8048926,99.1297213 85.5427468,99.7574496 84.654814,100.783761 C83.7668813,101.810073 83.3272098,103.149381 83.4340909,104.502273 L85.0909091,123.627273 C85.5879152,129.438254 90.5548926,133.838363 96.3834015,133.630982 C102.21191,133.423601 106.853607,128.68161 106.936364,122.85 L106.936364,145.227273 L145.8,145.227273 L145.8,103.193182 C145.8,100.933835 147.631562,99.1022727 149.890909,99.1022727 L149.890909,99.1022727 C156.927988,99.1015942 163.272427,94.8638964 165.968182,88.3636364 L172.104545,73.4113636 C172.606108,72.1421335 172.581693,70.7254365 172.036694,69.4742425 C171.491696,68.2230486 170.470966,67.2403291 169.2,66.7431818 Z"
            class="stroke"
            stroke-width="2.04545455"
            stroke-linecap="round"
            stroke-linejoin="round" />
          <path
            id="Path"
            d="M95.3181818,101.659091 C94.9154356,99.8642431 93.7081179,98.3550959 92.0454545,97.5681818 L91.8,91.0227273 C91.6466406,89.8193416 90.596209,88.9345615 89.384266,88.987951 C88.172323,89.0413406 87.2037637,90.015063 87.1568182,91.2272727 L87.4022727,97.0977273 C86.9611087,97.2206775 86.5302469,97.3779763 86.1136364,97.5681818 L83.3727273,92.1068182 C83.0292651,91.4235477 82.3473726,90.9754147 81.5839119,90.9312264 C80.8204513,90.8870381 80.0914104,91.2535079 79.6714119,91.8925901 C79.2514135,92.5316722 79.2042651,93.346275 79.5477273,94.0295455 L82.9431818,100.820455 C82.4571983,101.962282 82.3288245,103.224624 82.575,104.440909 C83.5802176,107.687575 86.9030835,109.624725 90.2236068,108.899859 C93.5441301,108.174994 95.7574207,105.02931 95.3181818,101.659091 Z"
            class="stroke fill-white"
            stroke-width="2.04545455"
            fill-rule="nonzero"
            stroke-linecap="round"
            stroke-linejoin="round" />
          <path
            id="Path"
            d="M90,99.1636364 C88.6443921,99.6098574 87.9071883,101.070528 88.3534092,102.426136 C88.7996302,103.781744 90.2603011,104.518948 91.6159091,104.072727 L94.0909091,103.275 C94.9905399,102.964385 95.4799709,101.994586 95.1954545,101.086364 L94.6431818,99.45 C94.502689,99.0156211 94.1950982,98.6550144 93.7883084,98.4477818 C93.3815186,98.2405493 92.908979,98.203731 92.475,98.3454545 L90,99.1636364 Z"
            class="stroke fill-white"
            stroke-width="2.04545455"
            fill-rule="nonzero"
            stroke-linecap="round"
            stroke-linejoin="round" />
          <path
            id="Path"
            d="M84.6409091,108.859091 C85.4337951,109.041784 86.2639174,108.787599 86.8185768,108.192286 C87.3732363,107.596973 87.568167,106.750973 87.3299405,105.972968 C87.0917139,105.194962 86.4565224,104.603147 85.6636364,104.420455 L83.2090909,103.847727 C82.6801399,103.725313 82.1242215,103.818217 81.6638167,104.10597 C81.2034119,104.393723 80.876298,104.852715 80.7545455,105.381818 L80.7545455,105.606818 C80.4437772,106.837369 81.1833852,108.08831 82.4113636,108.409091 L84.6409091,108.859091 Z"
            class="stroke fill-white"
            stroke-width="2.04545455"
            fill-rule="nonzero"
            stroke-linecap="round"
            stroke-linejoin="round" />
          <path
            id="Path"
            d="M85.1318182,104.318182 C85.9247042,104.500875 86.7548265,104.24669 87.309486,103.651377 C87.8641455,103.056064 88.0590763,102.210064 87.8208497,101.432058 C87.5826231,100.654053 86.9474315,100.062238 86.1545455,99.8795455 L83.7204545,99.3068182 C83.1915035,99.1844043 82.6355851,99.2773082 82.1751803,99.5650612 C81.7147755,99.8528143 81.3876617,100.311805 81.2659091,100.840909 L81.2659091,101.065909 C80.9855319,102.296908 81.7539473,103.522713 82.9840909,103.806818 L85.1318182,104.318182 Z"
            class="stroke fill-white"
            stroke-width="2.04545455"
            fill-rule="nonzero"
            stroke-linecap="round"
            stroke-linejoin="round" />
          <path
            id="Path"
            d="M163.636364,92.2704545 L155.863636,85.6636364 C154.533023,87.6633412 152.292846,88.8678198 149.890909,88.875 L134.652273,88.875 L126.470455,97.0568182 L118.288636,88.875 C114.563484,89.9286984 111.086357,91.7159417 108.061364,94.1318182 C100.940463,99.7394747 96.7861958,108.304351 96.7909091,117.368182 L96.7909091,122.931818 C96.7909091,123.327204 96.4703857,123.647727 96.075,123.647727 C95.6796143,123.647727 95.3590909,123.327204 95.3590909,122.931818 L95.0727273,120.681818 L84.8454545,121.438636 L84.8454545,121.438636 L85.05,123.770455 C85.5470061,129.581436 90.5139835,133.981545 96.3424924,133.774164 C102.171001,133.566782 106.812698,128.824792 106.895455,122.993182 L106.895455,145.227273 L145.759091,145.227273 L145.759091,103.193182 C145.759091,100.933835 147.590653,99.1022727 149.85,99.1022727 C155.257857,99.0929883 160.353479,96.5678582 163.636364,92.2704545 Z"
            class="fill-white"
            fill-rule="nonzero" />
          <line
            id="Path"
            x1="126.368182"
            y1="97.1590909"
            x2="126.368182"
            y2="145.227273"
            class="stroke"
            stroke-width="2.04545455"
            stroke-linecap="round"
            stroke-linejoin="round" />
          <path
            id="Path"
            d="M163.636364,92.2704545 L155.863636,85.6636364 C154.533023,87.6633412 152.292846,88.8678198 149.890909,88.875 L134.652273,88.875 L126.470455,97.0568182 L118.288636,88.875 C114.563484,89.9286984 111.086357,91.7159417 108.061364,94.1318182 C100.940463,99.7394747 96.7861958,108.304351 96.7909091,117.368182 L96.7909091,122.931818 C96.7909091,123.327204 96.4703857,123.647727 96.075,123.647727 C95.6796143,123.647727 95.3590909,123.327204 95.3590909,122.931818 L95.0727273,120.681818 L84.8454545,121.438636 L84.8454545,121.438636 L85.05,123.770455 C85.5470061,129.581436 90.5139835,133.981545 96.3424924,133.774164 C102.171001,133.566782 106.812698,128.824792 106.895455,122.993182 L106.895455,145.227273 L145.759091,145.227273 L145.759091,103.193182 C145.759091,100.933835 147.590653,99.1022727 149.85,99.1022727 C155.257857,99.0929883 160.353479,96.5678582 163.636364,92.2704545 Z"
            class="stroke"
            stroke-width="2.04545455"
            stroke-linecap="round"
            stroke-linejoin="round" />
          <path
            id="Path"
            d="M146.822727,60.3409091 L146.822727,55.2272727 C146.822727,43.9305392 137.664915,34.7727273 126.368182,34.7727273 C115.071448,34.7727273 105.913636,43.9305392 105.913636,55.2272727 L105.913636,60.3409091 C103.65429,60.3409091 101.822727,62.1724715 101.822727,64.4318182 C101.822727,66.6911649 103.65429,68.5227273 105.913636,68.5227273 L106.159091,68.5227273 C107.715519,78.4787775 116.291208,85.8179889 126.368182,85.8179889 C136.445156,85.8179889 145.020845,78.4787775 146.577273,68.5227273 L146.822727,68.5227273 C149.082074,68.5227273 150.913636,66.6911649 150.913636,64.4318182 C150.913636,62.1724715 149.082074,60.3409091 146.822727,60.3409091 Z"
            class="stroke fill-white"
            stroke-width="2.04545455"
            fill-rule="nonzero"
            stroke-linecap="round"
            stroke-linejoin="round" />
          <circle
            id="Oval"
            class="fill-light"
            fill-rule="nonzero"
            cx="114.606818"
            cy="69.0340909"
            r="2.55681818" />
          <circle
            id="Oval"
            class="fill-light"
            fill-rule="nonzero"
            cx="138.129545"
            cy="69.0340909"
            r="2.55681818" />
          <path
            id="Shape"
            d="M144.429545,74.9454545 C141.772487,77.294647 138.745301,79.1883658 135.470455,80.55 C135.712261,78.4323385 135.552656,76.2880722 135,74.2295455 C134.586056,72.654715 133.150856,71.5656518 131.522727,71.5909091 L121.295455,71.5909091 C119.674908,71.575108 118.250741,72.6621941 117.838636,74.2295455 C117.279125,76.2867697 117.112578,78.4310546 117.347727,80.55 C114.080098,79.1863767 111.05996,77.2927428 108.409091,74.9454545 L108.409091,74.9454545 C111.952592,81.6460807 118.911015,85.837768 126.490909,85.837768 C134.070803,85.837768 141.029226,81.6460807 144.572727,74.9454545 L144.429545,74.9454545 Z M128.7,82.4522727 C127.943182,82.5954545 127.165909,82.7181818 126.368182,82.8 C125.570455,82.8818182 124.793182,82.5954545 124.036364,82.4522727 C122.10086,82.0576079 120.723808,80.336294 120.763636,78.3613636 C120.763636,77.6454545 121.009091,75.7227273 121.765909,75.7227273 L130.909091,75.7227273 C131.665909,75.7227273 131.890909,77.6454545 131.911364,78.3613636 C131.957006,80.3175218 130.611049,82.0321167 128.7,82.4522727 L128.7,82.4522727 Z"
            class="stroke fill-white"
            stroke-width="2.04545455"
            fill-rule="nonzero"
            stroke-linejoin="round" />
          <line
            id="Path"
            x1="124.179545"
            y1="56.2909091"
            x2="128.556818"
            y2="56.2909091"
            class="stroke"
            stroke-width="2.04545455"
            stroke-linecap="round"
            stroke-linejoin="round" />
          <line
            id="Path"
            x1="123.647727"
            y1="59.3590909"
            x2="129.088636"
            y2="59.3590909"
            class="stroke"
            stroke-width="2.04545455"
            stroke-linecap="round"
            stroke-linejoin="round" />
          <path
            id="Path"
            d="M114.545455,67.5 C112.754649,67.6152922 111.003115,66.9409095 109.75203,65.6544168 C108.500945,64.367924 107.875696,62.5982551 108.040909,60.8113636 C108.327496,57.6396997 110.992714,55.2143513 114.177273,55.2272213 L124.404545,55.2272213 C123.811364,58.2340909 123.443182,67.5 114.545455,67.5 Z"
            class="fill-light"
            fill-rule="nonzero" />
          <path
            id="Path"
            d="M114.095455,55.2272213 C110.910895,55.2143513 108.245677,57.6396997 107.959091,60.8113636 C107.829782,62.1297749 108.123507,63.4551228 108.797727,64.5954545 L118.186364,55.2272213 L114.095455,55.2272213 Z"
            class="fill-white"
            fill-rule="nonzero" />
          <path
            id="Path"
            d="M114.545455,67.5 C112.754649,67.6152922 111.003115,66.9409095 109.75203,65.6544168 C108.500945,64.367924 107.875696,62.5982551 108.040909,60.8113636 C108.327496,57.6396997 110.992714,55.2143513 114.177273,55.2272213 L124.404545,55.2272213 C123.811364,58.2340909 123.443182,67.5 114.545455,67.5 Z"
            class="stroke"
            stroke-width="2.04545455"
            stroke-linecap="round"
            stroke-linejoin="round" />
          <path
            id="Path"
            d="M138.252273,67.5 C140.043078,67.6152922 141.794613,66.9409095 143.045697,65.6544168 C144.296782,64.367924 144.922032,62.5982551 144.756818,60.8113636 C144.470232,57.6396997 141.805014,55.2143513 138.620455,55.2272213 L128.393182,55.2272213 C128.863636,58.2340909 129.293182,67.5 138.252273,67.5 Z"
            class="fill-light"
            fill-rule="nonzero" />
          <path
            id="Path"
            d="M138.640909,55.2272727 L128.413636,55.2272727 C128.610687,58.0698402 129.353787,60.8477824 130.602273,63.4090909 L138.784091,55.2272727 L138.640909,55.2272727 Z"
            class="fill-white"
            fill-rule="nonzero" />
          <path
            id="Path"
            d="M138.252273,67.5 C140.043078,67.6152922 141.794613,66.9409095 143.045697,65.6544168 C144.296782,64.367924 144.922032,62.5982551 144.756818,60.8113636 C144.470232,57.6396997 141.805014,55.2143513 138.620455,55.2272213 L128.393182,55.2272213 C128.863636,58.2340909 129.293182,67.5 138.252273,67.5 Z"
            class="stroke"
            stroke-width="2.04545455"
            stroke-linecap="round"
            stroke-linejoin="round" />
          <circle
            id="Oval"
            class="stroke fill-white"
            stroke-width="2.04545455"
            fill-rule="nonzero"
            stroke-linejoin="round"
            cx="147.845455"
            cy="68.4818182"
            r="2.04545455" />
          <rect
            id="Rectangle"
            class="stroke fill-white"
            stroke-width="2.04545455"
            fill-rule="nonzero"
            stroke-linejoin="round"
            x="124.322727"
            y="36.8181818"
            width="4.09090909"
            height="8.18181818" />
          <rect
            id="Rectangle"
            class="stroke fill-white"
            stroke-width="2.04545455"
            fill-rule="nonzero"
            stroke-linejoin="round"
            transform="translate(118.691398, 41.145505) rotate(-7.290000) translate(-118.691398, -41.145505) "
            x="116.645944"
            y="37.0545958"
            width="4.09090909"
            height="8.18181818" />
          <rect
            id="Rectangle"
            class="stroke fill-white"
            stroke-width="2.04545455"
            fill-rule="nonzero"
            stroke-linejoin="round"
            transform="translate(134.009430, 41.139430) rotate(-82.710000) translate(-134.009430, -41.139430) "
            x="129.918521"
            y="39.0939753"
            width="8.18181818"
            height="4.09090909" />
          <rect
            id="Rectangle"
            class="stroke fill-light"
            stroke-width="2.04545455"
            fill-rule="nonzero"
            stroke-linejoin="round"
            x="114.095455"
            y="45"
            width="24.5454545"
            height="6.13636364"
            rx="2.12727273" />
          <path
            id="Path"
            d="M148.152273,48.8454545 C146.762772,37.8668609 137.42413,29.6356613 126.357955,29.6356613 C115.291779,29.6356613 105.953137,37.8668609 104.563636,48.8454545 C104.49308,49.4290427 104.677013,50.0147772 105.068522,50.4532675 C105.460031,50.8917578 106.021269,51.1406133 106.609091,51.1364172 L116.590909,51.1364172 C116.590909,42.9545455 121.111364,39.0272727 126.470455,38.8636364 C131.809091,39.0272727 136.35,42.9545455 136.35,51.1364172 L146.209091,51.1364172 C146.778946,51.1120295 147.31276,50.850863 147.681711,50.415889 C148.050662,49.9809151 148.221237,49.4116446 148.152273,48.8454545 Z"
            class="fill-light"
            fill-rule="nonzero" />
          <path
            id="Path"
            d="M148.152273,48.8454545 C146.762772,37.8668609 137.42413,29.6356613 126.357955,29.6356613 C115.291779,29.6356613 105.953137,37.8668609 104.563636,48.8454545 C104.49308,49.4290427 104.677013,50.0147772 105.068522,50.4532675 C105.460031,50.8917578 106.021269,51.1406133 106.609091,51.1364172 L116.590909,51.1364172 C116.590909,42.9545455 121.111364,39.0272727 126.470455,38.8636364 C131.809091,39.0272727 136.35,42.9545455 136.35,51.1364172 L146.209091,51.1364172 C146.778946,51.1120295 147.31276,50.850863 147.681711,50.415889 C148.050662,49.9809151 148.221237,49.4116446 148.152273,48.8454545 Z"
            class="stroke"
            stroke-width="2.04545455"
            stroke-linecap="round"
            stroke-linejoin="round" />
          <path
            id="Path"
            d="M111.252273,92.0454545 L119.434091,100.227273 C119.821755,100.653779 120.371367,100.89694 120.947727,100.89694 C121.524087,100.89694 122.0737,100.653779 122.461364,100.227273 C123.527552,98.9662498 124.86245,97.9598345 126.368182,97.2818182 L118.186364,89.1 C115.756312,89.7748575 113.425121,90.765098 111.252273,92.0454545 L111.252273,92.0454545 Z"
            class="stroke fill-light"
            stroke-width="2.04545455"
            fill-rule="nonzero"
            stroke-linecap="round"
            stroke-linejoin="round" />
          <path
            id="Path"
            d="M130.275,100.104545 C130.662664,100.531052 131.212276,100.774213 131.788636,100.774213 C132.364996,100.774213 132.914609,100.531052 133.302273,100.104545 L144.634091,88.7931818 L134.652273,88.7931818 L126.470455,96.975 C127.953897,97.724866 129.253111,98.7935746 130.275,100.104545 L130.275,100.104545 Z"
            class="stroke fill-light"
            stroke-width="2.04545455"
            fill-rule="nonzero"
            stroke-linecap="round"
            stroke-linejoin="round" />
          <path
            id="Path"
            d="M120.252273,120.681818 L117.184091,122.522727 C116.551225,122.888113 115.771502,122.888113 115.138636,122.522727 L112.070455,120.681818 C111.457102,120.308437 111.084455,119.640778 111.088602,118.922727 L111.088602,113.522727 C111.088602,112.393054 112.004418,111.477273 113.134091,111.477273 L119.270455,111.477273 C120.400128,111.477273 121.315909,112.393054 121.315909,113.522727 L121.315909,118.840909 C121.333178,119.605079 120.922933,120.315118 120.252273,120.681818 Z"
            class="stroke fill-white"
            stroke-width="2.04545455"
            fill-rule="nonzero"
            stroke-linecap="round"
            stroke-linejoin="round" />
          <path
            id="Path"
            d="M140.706818,120.681818 L137.638636,122.522727 C137.005771,122.888113 136.226048,122.888113 135.593182,122.522727 L132.525,120.681818 C131.911647,120.308437 131.539,119.640778 131.543147,118.922727 L131.543147,113.522727 C131.543147,112.393054 132.458963,111.477273 133.588636,111.477273 L139.725,111.477273 C140.854673,111.477273 141.770455,112.393054 141.770455,113.522727 L141.770455,118.840909 C141.787723,119.605079 141.377479,120.315118 140.706818,120.681818 L140.706818,120.681818 Z"
            class="stroke fill-white"
            stroke-width="2.04545455"
            fill-rule="nonzero"
            stroke-linecap="round"
            stroke-linejoin="round" />
          <line
            id="Path"
            x1="106.936364"
            y1="110.454545"
            x2="106.936364"
            y2="123.75"
            class="stroke"
            stroke-width="2.04545455"
            stroke-linecap="round"
            stroke-linejoin="round" />
          <rect
            id="Rectangle"
            class="fill-light"
            fill-rule="nonzero"
            x="156.027273"
            y="49.0909091"
            width="14.3181818"
            height="26.5909091"
            rx="2.04545455" />
          <rect
            id="Rectangle"
            class="stroke"
            stroke-width="2.04545455"
            stroke-linecap="round"
            stroke-linejoin="round"
            x="156.027273"
            y="49.0909091"
            width="14.3181818"
            height="26.5909091"
            rx="2.04545455" />
          <path
            id="Path"
            d="M160.118182,52.1590909 C159.553345,52.1590909 159.095455,52.6169815 159.095455,53.1818182 C159.095455,53.7466549 159.553345,54.2045455 160.118182,54.2045455 C160.683018,54.2045455 161.140909,53.7466549 161.140909,53.1818182 C161.140909,52.6169815 160.683018,52.1590909 160.118182,52.1590909 Z"
            fill="#0066A4"
            fill-rule="nonzero" />
          <path
            id="Path"
            d="M162.347727,68.3181818 C162.629556,70.3130873 164.321881,71.8058049 166.336364,71.8363636 L171.327273,71.8363636 C173.013991,71.8591896 174.402781,70.5160843 174.436364,68.8295455 L174.559091,62.6931818 C174.581915,60.9951676 173.229654,59.5972214 171.531818,59.5636364 L166.561364,59.5636364 C164.560894,59.5310062 162.830321,60.950076 162.470455,62.9181818 C162.194338,64.7051371 162.153079,66.5205273 162.347727,68.3181818 L162.347727,68.3181818 Z"
            class="fill-white"
            fill-rule="nonzero" />
          <path
            id="Path"
            d="M162.347727,68.3181818 C162.629556,70.3130873 164.321881,71.8058049 166.336364,71.8363636 L171.327273,71.8363636 C173.013991,71.8591896 174.402781,70.5160843 174.436364,68.8295455 L174.559091,62.6931818 C174.581915,60.9951676 173.229654,59.5972214 171.531818,59.5636364 L166.561364,59.5636364 C164.560894,59.5310062 162.830321,60.950076 162.470455,62.9181818 C162.194338,64.7051371 162.153079,66.5205273 162.347727,68.3181818 L162.347727,68.3181818 Z"
            class="stroke"
            stroke-width="2.04545455"
            stroke-linecap="round"
            stroke-linejoin="round" />
          <line
            id="Path"
            x1="111.027273"
            y1="115.568182"
            x2="121.254545"
            y2="115.568182"
            class="stroke"
            stroke-width="2.04545455"
            stroke-linecap="round"
            stroke-linejoin="round" />
          <line
            id="Path"
            x1="131.481818"
            y1="115.568182"
            x2="141.709091"
            y2="115.568182"
            class="stroke"
            stroke-width="2.04545455"
            stroke-linecap="round"
            stroke-linejoin="round" />
        </g>
      </g>
    </g>
  </svg>
</template>

<style lang="scss" rel="stylesheet/scss" scoped>
  @use '@/styles/variables.scss' as *;

  .fill-extra-light {
    fill: var(--iconColorFaded9);
  }

  .stroke {
    stroke: var(--iconColor);
  }

  .fill-light {
    fill: var(--iconColorFaded6);
  }

  .fill-white {
    fill: #ffffff;
  }
</style>
